export const CONFIGURATOR_PATHS = {
	OFFER_REVIEW: '/wybierz-pakiet',
	OFFER: '/wybierz-pakiet/oferta',
	SUMMARY: '/wybierz-pakiet/podsumowanie',
	PAYMENT_METHOD: '/wybierz-pakiet/metoda-platnosci'
};
